import { render, staticRenderFns } from "./TocAwareContainer.vue?vue&type=template&id=28cab2fc&scoped=true&"
import script from "./TocAwareContainer.vue?vue&type=script&lang=js&"
export * from "./TocAwareContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cab2fc",
  null
  
)

export default component.exports